import * as React from "react";
import { Stack, Typography } from "@mui/material";
import moment from "moment/moment";
import { AppLogo, useFormatAmount } from "../../../shared";

export const GiftCardItem = ({ cardDetails }) => {
  const formatAmount = useFormatAmount();

  return (
    <>
      <Stack
        sx={{
          p: "24px",
          // bgcolor: "#032D6F",
          background: `linear-gradient(160deg, #FFFFFF 20%, #EDEDED 60%)`,
          border: "1px solid #EDEDED",
          borderRadius: "24px",
          minWidth: "450px",
          minHeight: "250px",
          justifyContent: "space-between",
          boxShadow: "0px 1.42834px 2.85668px rgba(0, 0, 0, 0.25)",
        }}
      >
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Stack
            sx={{
              gap: "4px",
            }}
          >
            <Typography variant="h4" lineHeight="39px">
              {formatAmount(cardDetails?.balance_value)}
            </Typography>
            <Typography variant="subtitle1" lineHeight="19px" fontWeight={400}>
              Balance
            </Typography>
          </Stack>
          <Stack direction="column" alignItems="end">
            {/* <img
              src={LogoBlack}
              alt="logo"
              style={{
                width: "103px",
                height: "32px",
              }}
            /> */}
            <AppLogo
              alt="logo"
              sx={{
                maxHeight: "32px",
                maxWidth: "103px",
                objectFit: "contain",
              }}
              skeletonSx={{ width: 103, height: 32 }}
            />
            <Typography
              variant="subtitle1"
              lineHeight="19.36px"
              fontWeight={500}
            >
              Gift Card
            </Typography>
          </Stack>
        </Stack>
        <Stack>
          <Typography variant="h5" lineHeight="17px">
            {cardDetails?.card_number}
          </Typography>
        </Stack>
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Stack gap="6px" justifyContent="center" marginTop="auto">
            <Typography variant="subtitle2" lineHeight="15px">
              Valid Up To :
            </Typography>
            <Typography variant="h6" lineHeight="17px">
              {cardDetails.expiry_date
                ? moment(cardDetails.expiry_date, "DD/MM/YYYY, hh:mm A").format(
                    "DD MMM YYYY",
                  )
                : "N/A"}
            </Typography>
          </Stack>
          <Stack
            direction="column"
            width="232px"
            height="100.31px"
            sx={{
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              p: "8px",
              background: "#FFFFFF",
              borderRadius: "4px",
            }}
          >
            <Typography fontWeight={500} fontSize="14px">
              Verification Code: {cardDetails.verification_code}
            </Typography>
            <img
              alt="barcode"
              src="/icons/barcode.png"
              style={{
                width: "198.04px",
                height: "28.31px",
                alignSelf: "center",
              }}
            />
            <Typography fontWeight={500} fontSize="14px">
              {cardDetails.barcode}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
